import { gql } from 'graphql-request'

// Legacy query - keeping for backwards compatibility
export const availableCorporateUserCorporateThirdPartyIntegrationsQuery = gql`
  query AvailableCorporateUserCorporateThirdPartyIntegrations {
    availableCorporateUserCorporateThirdPartyIntegrations {
      id
      name
      description
      keys {
        id
        name
      }
    }
  }
`

export const corporateQuery = gql`
  query Corporate($corporateId: String!) {
    corporate(corporateId: $corporateId) {
      corporateId
      integrations {
        classPass {
          enabled
          siteIds
        }
      }
    }
  }
`
export const corporateBySubdomainQuery = gql`
  query CorporateBySubdomain($subdomain: String!) {
    corporateBySubdomain(subdomain: $subdomain) {
      corporateId
      name
      urlPrefix
      planTier
      logoImage(input: { type: small, format: jpeg }) {
        url
        type
        width
        height
      }
      dashboardHeroImage(input: { type: large, format: jpeg }) {
        url
        type
        width
        height
      }
      communicationSettings {
        email {
          defaultFromName
          defaultFromEmail
        }
      }
      paymentAuthorisationConfig {
        cancellationPolicy
        customerServiceContact
      }
    }
  }
`
